"use client";
import React, { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

export default function MetaPixel ({id}: {id: string}) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    import("react-facebook-pixel")
      .then((x) => x.default)
      .then((ReactPixel) => {
        ReactPixel.init(id);
        ReactPixel.pageView();
      });
  }, [pathname, searchParams]);

  return <></>;
};